import { NJFormItem } from "@engie-group/fluid-design-system-react";
import { Box } from "@mui/material";
import FluidSelect from "../../../../../common/components/FluidSelect";
import {
	NegativePriceType,
	Operator,
} from "../../../../../requests_cm/gecoContractsService/types";
import { getSyntheticEvent } from "../../../../../common/utils/getSyntheticEvent";
import { useMemo } from "react";
import { PriceIndex } from "../../../../../requests_cm/gecoReferentialService/types";
import { useTranslation } from "react-i18next";

const style = {
	container: {
		width: 200,
	},
	wrapper: {
		display: "flex",
		flexDirection: "row",
		gap: "16px",
		flexWrap: "wrap",
	},
};

export interface NegativePriceInputsProps {
	onChange: (event: any) => void;
	currentNegativePriceIndex?: number;
	negativePriceIndexes: PriceIndex[];
	negativePriceValue?: number;
	negativePriceType?: NegativePriceType;
	isReadOnly?: boolean;
	threshold?: number;
	comparator?: Operator;
	nb_consecutive_blocks?: number;
}

export const NegativePriceInputs = (props: NegativePriceInputsProps) => {
	const availableOptions = useMemo(() => {
		return (props.negativePriceIndexes || []).map((index: PriceIndex) => ({
			value: `${index.orchestrade_id}`,
			label: index.name,
		}));
	}, [props.negativePriceIndexes]);
	const { t } = useTranslation();
	return (
		<Box sx={style.wrapper}>
			<Box sx={style.container}>
				<FluidSelect
					isLabelStatic
					items={availableOptions}
					label={`${t("contract_periods.settlements.negative_price")} Index`}
					name={"index"}
					// @ts-ignore does not provides an HTMLElement as it should but the value itself
					onChange={(index: number) => {
						props.onChange(getSyntheticEvent("index", index));
						props.onChange(
							getSyntheticEvent(
								"name",
								(availableOptions || []).find(
									(indexOption) =>
										indexOption.value === `${index}`
								)?.label || ""
							)
						);
					}}
					value={`${props.currentNegativePriceIndex}`}
					isReadOnly={props.isReadOnly}
				/>
			</Box>
			<Box sx={style.container}>
				<FluidSelect
					isReadOnly={props.isReadOnly}
					isLabelStatic
					items={[
						{
							label: NegativePriceType.PRICE,
							value: NegativePriceType.PRICE,
						},
						{
							label: NegativePriceType.CENTS,
							value: NegativePriceType.CENTS,
						},
					]}
					label={`${t("contract_periods.settlements.negative_price")} Type`}
					name={"type"}
					// @ts-ignore does not provides an HTMLElement as it should but the value itself
					onChange={(type: NegativePriceType) =>
						props.onChange(getSyntheticEvent("type", type))
					}
					value={props.negativePriceType}
				/>
			</Box>
			<Box sx={style.container}>
				<NJFormItem
					id="value"
					label={`${t("contract_periods.settlements.negative_price")} Value`}
					labelKind="static"
					name="value"
					type="number"
					// @ts-ignore Typing issue coming from package, expecting string...
					value={props.negativePriceValue}
					onChange={props.onChange}
					title={`${t("contract_periods.settlements.negative_price")} Value`}
					wrap="soft"
					readOnly={props.isReadOnly}
				/>
			</Box>
			<Box sx={style.container}>
				<FluidSelect
					isLabelStatic
					items={[
						{
							label: "<",
							value: Operator.LOWER_THAN,
						},
						{
							label: "<=",
							value: Operator.LOWER_THAN_OR_EQUAL,
						},
					]}
					label={"Comparator"}
					name={"comparator"}
					// @ts-ignore does not provides an HTMLElement as it should but the value itself
					onChange={(comparator: Operator) =>
						props.onChange(
							getSyntheticEvent("comparator", comparator)
						)
					}
					value={props.comparator}
				/>
			</Box>
			<Box sx={style.container}>
				<NJFormItem
					id="threshold"
					label="Threshold"
					labelKind="static"
					name="threshold"
					type="number"
					// @ts-ignore Typing issue coming from package, expecting string...
					value={props.threshold}
					onChange={props.onChange}
					title="threshold"
					wrap="soft"
				/>
			</Box>
			<Box sx={style.container}>
				<NJFormItem
					id="nb_consecutive_blocks"
					label="Consecutive blocks"
					labelKind="static"
					name="nb_consecutive_blocks"
					type="number"
					// @ts-ignore Typing issue coming from package, expecting string...
					value={props.nb_consecutive_blocks}
					onChange={props.onChange}
					title="Consectuive blocks"
					wrap="soft"
				/>
			</Box>
		</Box>
	);
};
